import React from 'react'
import { SecondaryButton } from '../Ui'

const FAQButton = ({ onClick }) => (
	<SecondaryButton
		iconName="help"
		raised
		onClick={onClick}>

		Aide
	</SecondaryButton>
)

export default FAQButton



// WEBPACK FOOTER //
// ./src/js/faq/FAQButton.js